export { useGetSearchTableDocuments } from '@dc-shared-web/hooks/api/document/useGetSearchTableDocuments'
export { useGetSharedDocumentInfo } from '@dc-shared-web/hooks/api/document/useGetSharedDocumentInfo'
export { useMoveDocumentToFolder } from '@dc-shared-web/hooks/api/document/useMoveDocumentToFolder'
export { useMoveDocumentToProject } from '@dc-shared-web/hooks/api/document/useMoveDocumentToProject'
export { useRenameDocument } from '@dc-shared-web/hooks/api/document/useRenameDocument'
export { useResendSharedDocument } from '@dc-shared-web/hooks/api/document/useResendSharedDocument'
export { useRevokeSharedDocument } from '@dc-shared-web/hooks/api/document/useRevokeSharedDocument'
export { useShareDocument } from '@dc-shared-web/hooks/api/document/useShareDocument'
export { useUpdateDocumentState } from '@dc-shared-web/hooks/api/document/useUpdateDocumentState'
export { useGetDocumentById } from '@dc-shared-web/hooks/api/document/useGetDocumentById'
export { useGetProcessingDocuments } from '@dc-shared-web/hooks/api/document/useGetProcessingDocuments'
export { fetchProcessingDocuments } from '@dc-shared-web/hooks/api/document/fetchProcessingDocuments'
export { useGetMainTableDocuments } from '@dc-shared-web/hooks/api/document/useGetMainTableDocuments'
export { useGetOriginalPdf } from '@dc-shared-web/hooks/api/document/useGetOriginalPdf'

export { UDR_SOLUTION_TYPE_NAME } from '@dc-shared-web/hooks/api/document/constants'

export type {
  DocumentSearchResult,
  SharedDocumentInfo,
  SharedDocumentInfoReponse,
} from '@dc-shared-web/hooks/api/document/types'
export type { GetMainTableQueryParams } from '@dc-shared-web/hooks/api/document/fetchMainTableDocuments'
